var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCatalogs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 227,
    height: 227,
    viewBox: "0 0 227 227",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1111_2997)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 31,
    width: 157,
    height: 157,
    rx: 78.5,
    fill: "white",
    fillOpacity: 0.1,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90.2019 81C87.0769 81 84.5 83.5751 84.5 86.7V101.898C84.5 105.023 87.0769 107.598 90.2019 107.598H105.398C108.523 107.598 111.1 105.023 111.1 101.898V86.7C111.1 83.5751 108.523 81 105.398 81H90.2019ZM120.602 81C117.477 81 114.902 83.5751 114.902 86.7V101.898C114.902 105.023 117.477 107.598 120.602 107.598H135.798C138.923 107.598 141.5 105.023 141.5 101.898V86.7C141.5 83.5751 138.923 81 135.798 81H120.602ZM90.2019 111.4C87.0769 111.4 84.5 113.977 84.5 117.102V132.298C84.5 135.423 87.0769 138 90.2019 138H105.398C108.523 138 111.1 135.423 111.1 132.298V117.102C111.1 113.977 108.523 111.4 105.398 111.4H90.2019ZM128.196 111.4C120.873 111.4 114.902 117.381 114.902 124.704C114.902 132.027 120.873 138 128.196 138C135.519 138 141.5 132.027 141.5 124.704C141.5 117.381 135.519 111.4 128.196 111.4Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1111_2997",
    x: 0.700001,
    y: 0.700001,
    width: 225.6,
    height: 225.6,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 17.15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.6 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1111_2997"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1111_2997",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCatalogs);
export default __webpack_public_path__ + "static/media/catalogs.765c62411c938d4cba1e6f0eb8065457.svg";
export { ForwardRef as ReactComponent };